"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarEditMainInfo = void 0;
var react_1 = __importStar(require("react"));
var messageContext_1 = require("../../hoc/messageContext");
var useCarEditMainInfo_1 = require("../../hook/useCarEditMainInfo");
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var select_1 = __importDefault(require("antd/es/select"));
var typography_1 = __importDefault(require("antd/es/typography"));
var Title = typography_1.default.Title;
var CarEditMainInfo = function () {
    var _a = (0, messageContext_1.useMessageContext)(), showSuccess = _a.showSuccess, showError = _a.showError;
    var form = form_1.default.useForm()[0];
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var _c = (0, useCarEditMainInfo_1.useCarEditMainInfo)(), car = _c[0], modelValues = _c[1], generationValues = _c[2];
    if (!car) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var onFinish = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    if (!car)
                        return [2 /*return*/];
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/cars/").concat(car.id), {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(values),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess('Данные успешно обновлены');
                    }
                    else {
                        throw new Error('Ошибка при обновлении');
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    showError('Ошибка при обновлении данных');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Title, { level: 1, style: { marginBottom: '20px' } }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438"),
        react_1.default.createElement(form_1.default, { form: form, layout: "vertical", initialValues: {
                model_id: car.models.id,
                generation_id: car.generations.id,
                year: car.year,
                price: car.price,
                color_id: car.colors.id,
                body_type_id: car.body_types.id,
                engine_type_id: car.engine_name_types.id,
                gearbox_type_id: car.gearbox_types.id,
                drive_type_id: car.drive_types.id,
                complectation_name: car.complectation_name,
                description: car.description,
                availability: car.online_view_available,
            }, onFinish: onFinish },
            react_1.default.createElement(form_1.default.Item, { label: "\u0411\u0440\u0435\u043D\u0434" },
                react_1.default.createElement(input_1.default, { value: car.brands.name, disabled: true, style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
            react_1.default.createElement(form_1.default.Item, { name: "model_id", label: "\u041C\u043E\u0434\u0435\u043B\u044C", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null, modelValues.map(function (item) { return (react_1.default.createElement(select_1.default.Option, { key: item.id, value: item.id }, item.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "generation_id", label: "\u041F\u043E\u043A\u043E\u043B\u0435\u043D\u0438\u0435", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null, generationValues.map(function (item) { return (react_1.default.createElement(select_1.default.Option, { key: item.id, value: item.id }, item.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "year", label: "\u0413\u043E\u0434", rules: [{ required: true }] },
                react_1.default.createElement(input_1.default, { type: "number", min: 1885 })),
            react_1.default.createElement(form_1.default.Item, { name: "price", label: "\u0426\u0435\u043D\u0430", rules: [{ required: true }] },
                react_1.default.createElement(input_1.default, { type: "number", min: 0 })),
            react_1.default.createElement(form_1.default.Item, { name: "color_id", label: "\u0426\u0432\u0435\u0442", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null, car.all_colors.map(function (item) { return (react_1.default.createElement(select_1.default.Option, { key: item.id, value: item.id }, item.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "body_type_id", label: "\u0422\u0438\u043F \u043A\u0443\u0437\u043E\u0432\u0430", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null, car.all_body_types.map(function (item) { return (react_1.default.createElement(select_1.default.Option, { key: item.id, value: item.id }, item.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "engine_type_id", label: "\u0422\u0438\u043F \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null, car.all_engine_name_types.map(function (item) { return (react_1.default.createElement(select_1.default.Option, { key: item.id, value: item.id }, item.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "gearbox_type_id", label: "\u0422\u0438\u043F \u041A\u041F\u041F", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null, car.all_gearbox_types.map(function (item) { return (react_1.default.createElement(select_1.default.Option, { key: item.id, value: item.id }, item.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "drive_type_id", label: "\u0422\u0438\u043F \u043F\u0440\u0438\u0432\u043E\u0434\u0430", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null, car.all_drive_types.map(function (item) { return (react_1.default.createElement(select_1.default.Option, { key: item.id, value: item.id }, item.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "complectation_name", label: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F" },
                react_1.default.createElement(input_1.default, { placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438" })),
            react_1.default.createElement(form_1.default.Item, { name: "description", label: "\u041A\u043E\u0440\u043E\u0442\u043A\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435" },
                react_1.default.createElement(input_1.default.TextArea, { rows: 1, placeholder: "\u0411\u0440\u0435\u043D\u0434, \u043C\u0430\u0440\u043A\u0430, \u0433\u043E\u0434, \u043C\u043E\u0449\u043D\u043E\u0441\u0442\u044C", maxLength: 100, showCount: true })),
            react_1.default.createElement(form_1.default.Item, { name: "availability", label: "\u041D\u0430\u043B\u0438\u0447\u0438\u0435", rules: [{ required: true }] },
                react_1.default.createElement(select_1.default, null,
                    react_1.default.createElement(select_1.default.Option, { value: true }, "\u0412 \u043D\u0430\u043B\u0438\u0447\u0438\u0438"),
                    react_1.default.createElement(select_1.default.Option, { value: false }, "\u041D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438"))),
            react_1.default.createElement(form_1.default.Item, null,
                react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: loading }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F")))));
};
exports.CarEditMainInfo = CarEditMainInfo;
